import React, { useState } from "react"
import styled, { css } from "styled-components"
import { css as GlobalCss } from "../styles/GlobalStyles"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faVolumeUp, faEnvelope } from "@fortawesome/free-solid-svg-icons"

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  
  color: var(--white);
  height: 100%;
`

const Info = styled.div`
  text-align: left;

  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;

  border-left: 5px solid white;
  padding-left: 0.7rem;
  margin-right: 15px;

  @media (min-width: ${GlobalCss.breakpoints.split}) {
    text-align: center;
    margin-left: 0;
    border: none;
  }
`

const Name = styled.div``

const Role = styled.div`
  font-size: var(--font-small);
  line-height: var(--line-small);
`

const PronunciationIcon = styled(FontAwesomeIcon)`
  margin-right: 0.25rem;
`

const Pronunciation = styled.div`
  font-size: var(--font-small);
  line-height: var(--line-small);
  color: var(--gray-text);

  @media (min-width: ${GlobalCss.breakpoints.split}) {
    margin-top: 0.25rem;
  }
`

type ExpandableEmail = {
  $isExpanded: boolean
}

const MailContainerMobile = styled.div`
  min-width: 1.5rem;
  height: 1.5rem;
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (min-width: ${GlobalCss.breakpoints.split}) {
    display: none;
  }
`

const MailIconMobile = styled(FontAwesomeIcon)<ExpandableEmail>`
  position: relative;
  z-index: 10;
  cursor: pointer;
  color: var(--gray-bg);
  transition: color 0.5s;

  ${props => props.$isExpanded && css`
    color: var(--black);
  `}
`

const EmailContainerMobile = styled.div<ExpandableEmail>`
  background-color: var(--white);
  color: var(--black);
  font-size: var(--font-small);
  line-height: 1.5rem;

  position: absolute;
  z-index: 0;
  top: 0;
  right: -5px;
  height: 1.5rem;
  padding-left: 0.5rem;
  border-radius: 15px;
  overflow: hidden;
  width: 8.5rem;
  transition: width 0.5s;

  ${props => !props.$isExpanded && css`
    padding: 0;
    margin: 0;
    width: 0;
  `}
`

const MailSplit = styled.div`
  font-size: var(--font-small);
  line-height: var(--line-small);
  color: var(--gray-text);
  display: flex;
  gap: 5px;
  justify-content: center;
  align-items: center;

  @media (max-width: ${GlobalCss.breakpoints.split}) {
    display: none;
  }
`

type Props = {
  name: string
  job: string
  pronunciation: string
  email: string
}

const ProfileInfo = ({name, job, pronunciation, email}: Props) => {
  const [isShowingEmail, setIsShowingEmail] = useState(false)
  const toggleEmail = () => {setIsShowingEmail(!isShowingEmail)}

  return (
    <InfoContainer>
      <Info>

        <Name>{name}</Name>
        <Role>{job}</Role>
        <Pronunciation>
          <PronunciationIcon icon={faVolumeUp}/>
          <span>{pronunciation}</span>
        </Pronunciation>

        <MailContainerMobile>
            <EmailContainerMobile $isExpanded={isShowingEmail}>
              {email}
            </EmailContainerMobile>
          <MailIconMobile
            icon={faEnvelope}
            onClick={toggleEmail}
            $isExpanded={isShowingEmail}/>
        </MailContainerMobile>

        <MailSplit>
          <FontAwesomeIcon icon={faEnvelope} style={{ marginTop: "2px" }} />
          {email}
        </MailSplit>

      </Info>
    </InfoContainer>
  )
}

export default ProfileInfo